export const analyticsAnimated = (isDarkMode: boolean) => ({
    nm: 'Main Scene',
    ddd: 0,
    h: 93,
    w: 112,
    meta: {
        g: '@lottiefiles/creator 1.44.0'
    },
    layers: [
        {
            ty: 4,
            nm: 'Layer 2 Outlines',
            sr: 1,
            st: 0,
            op: 360,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        1.379,
                        1.632,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                0,
                                0,
                                100
                            ],
                            t: 0
                        },
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                100,
                                100,
                                100
                            ],
                            t: 6
                        },
                        {
                            s: [
                                83.9631,
                                83.9631
                            ],
                            t: 141
                        }
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        32.7888,
                        48.9551
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ],
                                        [
                                            0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.763
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.763
                                        ],
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ]
                                    ],
                                    v: [
                                        [
                                            -0.001,
                                            1.382
                                        ],
                                        [
                                            1.378,
                                            0
                                        ],
                                        [
                                            -0.001,
                                            -1.382
                                        ],
                                        [
                                            -1.378,
                                            0
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    1.629,
                                    1.632
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 1
        },
        {
            ty: 4,
            nm: 'Layer 4 Outlines',
            sr: 1,
            st: 27,
            op: 387,
            ip: 27,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        1.629,
                        1.632,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                0,
                                0,
                                100
                            ],
                            t: 27
                        },
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                100,
                                100,
                                100
                            ],
                            t: 33
                        },
                        {
                            s: [
                                83.9631,
                                83.9631
                            ],
                            t: 141
                        }
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        44.9953,
                        38.9341
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ],
                                        [
                                            0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.764
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.764
                                        ],
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ]
                                    ],
                                    v: [
                                        [
                                            -0.001,
                                            1.382
                                        ],
                                        [
                                            1.378,
                                            0
                                        ],
                                        [
                                            -0.001,
                                            -1.382
                                        ],
                                        [
                                            -1.378,
                                            0
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    1.629,
                                    1.632
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 2
        },
        {
            ty: 4,
            nm: 'Layer 3 Outlines',
            sr: 1,
            st: 47,
            op: 407,
            ip: 47,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        1.754,
                        1.882,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                0,
                                0,
                                100
                            ],
                            t: 47
                        },
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                100,
                                100,
                                100
                            ],
                            t: 53
                        },
                        {
                            s: [
                                83.9631,
                                83.9631
                            ],
                            t: 141
                        }
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        57.2027,
                        32.2867
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ],
                                        [
                                            0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.764
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.764
                                        ],
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ]
                                    ],
                                    v: [
                                        [
                                            -0.001,
                                            1.382
                                        ],
                                        [
                                            1.378,
                                            0
                                        ],
                                        [
                                            -0.001,
                                            -1.382
                                        ],
                                        [
                                            -1.378,
                                            0
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    1.629,
                                    1.632
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 3
        },
        {
            ty: 4,
            nm: 'Layer 5 Outlines',
            sr: 1,
            st: 68,
            op: 428,
            ip: 68,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        1.629,
                        1.507,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                0,
                                0,
                                100
                            ],
                            t: 68
                        },
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                100,
                                100,
                                100
                            ],
                            t: 74
                        },
                        {
                            s: [
                                83.9631,
                                83.9631
                            ],
                            t: 141
                        }
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        69.0944,
                        25.3262
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ],
                                        [
                                            0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.763
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.763
                                        ],
                                        [
                                            -0.761,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ]
                                    ],
                                    v: [
                                        [
                                            -0.001,
                                            1.382
                                        ],
                                        [
                                            1.379,
                                            0
                                        ],
                                        [
                                            -0.001,
                                            -1.382
                                        ],
                                        [
                                            -1.379,
                                            0
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    1.629,
                                    1.632
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 4
        },
        {
            ty: 4,
            nm: 'Layer 14 Outlines',
            sr: 1,
            st: 92,
            op: 452,
            ip: 92,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        1.754,
                        1.507,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 1,
                    k: [
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                0,
                                0,
                                100
                            ],
                            t: 92
                        },
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                100,
                                100,
                                100
                            ],
                            t: 98
                        },
                        {
                            s: [
                                83.9631,
                                83.9631
                            ],
                            t: 141
                        }
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        81.1952,
                        13.7225
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ],
                                        [
                                            0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.764
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            -0.764
                                        ],
                                        [
                                            -0.762,
                                            0
                                        ],
                                        [
                                            0,
                                            0.763
                                        ]
                                    ],
                                    v: [
                                        [
                                            0,
                                            1.382
                                        ],
                                        [
                                            1.379,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.382
                                        ],
                                        [
                                            -1.379,
                                            0
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    1.629,
                                    1.632
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 5
        },
        {
            ty: 4,
            nm: 'Layer 6 Outlines',
            sr: 1,
            st: 0,
            op: 360,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0.01,
                        10.175,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        28.8509,
                        64.5143
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.228,
                                                        9.825
                                                    ],
                                                    [
                                                        -2.322,
                                                        9.825
                                                    ],
                                                    [
                                                        -3.807,
                                                        11.314
                                                    ],
                                                    [
                                                        -3.76,
                                                        8.436
                                                    ],
                                                    [
                                                        -2.275,
                                                        9.926
                                                    ],
                                                    [
                                                        2.275,
                                                        9.926
                                                    ],
                                                    [
                                                        3.76,
                                                        8.436
                                                    ],
                                                    [
                                                        3.713,
                                                        11.314
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 0
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.275,
                                                        -9.926
                                                    ],
                                                    [
                                                        -2.275,
                                                        -9.926
                                                    ],
                                                    [
                                                        -3.76,
                                                        -8.436
                                                    ],
                                                    [
                                                        -3.76,
                                                        8.436
                                                    ],
                                                    [
                                                        -2.275,
                                                        9.926
                                                    ],
                                                    [
                                                        2.275,
                                                        9.926
                                                    ],
                                                    [
                                                        3.76,
                                                        8.436
                                                    ],
                                                    [
                                                        3.76,
                                                        -8.436
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 13
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    4.01,
                                    10.175
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 6
        },
        {
            ty: 4,
            nm: 'Layer 7 Outlines',
            sr: 1,
            st: 13,
            op: 373,
            ip: 13,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0.01,
                        16.143,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        40.8475,
                        59.5034
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.266,
                                                        16.107
                                                    ],
                                                    [
                                                        -2.284,
                                                        16.107
                                                    ],
                                                    [
                                                        -3.769,
                                                        17.596
                                                    ],
                                                    [
                                                        -3.76,
                                                        14.404
                                                    ],
                                                    [
                                                        -2.275,
                                                        15.893
                                                    ],
                                                    [
                                                        2.275,
                                                        15.893
                                                    ],
                                                    [
                                                        3.76,
                                                        14.404
                                                    ],
                                                    [
                                                        3.751,
                                                        17.596
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 13
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.275,
                                                        -15.893
                                                    ],
                                                    [
                                                        -2.275,
                                                        -15.893
                                                    ],
                                                    [
                                                        -3.76,
                                                        -14.404
                                                    ],
                                                    [
                                                        -3.76,
                                                        14.404
                                                    ],
                                                    [
                                                        -2.275,
                                                        15.893
                                                    ],
                                                    [
                                                        2.275,
                                                        15.893
                                                    ],
                                                    [
                                                        3.76,
                                                        14.404
                                                    ],
                                                    [
                                                        3.76,
                                                        -14.404
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 39
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    4.01,
                                    16.143
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 7
        },
        {
            ty: 4,
            nm: 'Layer 8 Outlines',
            sr: 1,
            st: 30,
            op: 390,
            ip: 30,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0.01,
                        20.289,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        52.8442,
                        56.0231
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.821,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.821,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.304,
                                                        20.461
                                                    ],
                                                    [
                                                        -2.245,
                                                        20.461
                                                    ],
                                                    [
                                                        -3.731,
                                                        21.95
                                                    ],
                                                    [
                                                        -3.76,
                                                        18.549
                                                    ],
                                                    [
                                                        -2.274,
                                                        20.039
                                                    ],
                                                    [
                                                        2.275,
                                                        20.039
                                                    ],
                                                    [
                                                        3.76,
                                                        18.549
                                                    ],
                                                    [
                                                        3.789,
                                                        21.95
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 30
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.821,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.821,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.823
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.275,
                                                        -20.039
                                                    ],
                                                    [
                                                        -2.274,
                                                        -20.039
                                                    ],
                                                    [
                                                        -3.76,
                                                        -18.55
                                                    ],
                                                    [
                                                        -3.76,
                                                        18.549
                                                    ],
                                                    [
                                                        -2.274,
                                                        20.039
                                                    ],
                                                    [
                                                        2.275,
                                                        20.039
                                                    ],
                                                    [
                                                        3.76,
                                                        18.549
                                                    ],
                                                    [
                                                        3.76,
                                                        -18.55
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 64
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    4.01,
                                    20.289
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 8
        },
        {
            ty: 4,
            nm: 'Layer 9 Outlines',
            sr: 1,
            st: 49,
            op: 409,
            ip: 49,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0.009,
                        24.246,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        64.8408,
                        52.6998
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.343,
                                                        24.254
                                                    ],
                                                    [
                                                        -2.207,
                                                        24.254
                                                    ],
                                                    [
                                                        -3.692,
                                                        25.743
                                                    ],
                                                    [
                                                        -3.759,
                                                        22.508
                                                    ],
                                                    [
                                                        -2.275,
                                                        23.997
                                                    ],
                                                    [
                                                        2.275,
                                                        23.997
                                                    ],
                                                    [
                                                        3.759,
                                                        22.508
                                                    ],
                                                    [
                                                        3.827,
                                                        25.743
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 49
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.275,
                                                        -23.997
                                                    ],
                                                    [
                                                        -2.275,
                                                        -23.997
                                                    ],
                                                    [
                                                        -3.759,
                                                        -22.507
                                                    ],
                                                    [
                                                        -3.759,
                                                        22.508
                                                    ],
                                                    [
                                                        -2.275,
                                                        23.997
                                                    ],
                                                    [
                                                        2.275,
                                                        23.997
                                                    ],
                                                    [
                                                        3.759,
                                                        22.508
                                                    ],
                                                    [
                                                        3.759,
                                                        -22.507
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 93
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    4.01,
                                    24.247
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 9
        },
        {
            ty: 4,
            nm: 'Layer 10 Outlines',
            sr: 1,
            st: 52,
            op: 412,
            ip: 52,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0.009,
                        31.156,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        76.8375,
                        46.898
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.381,
                                                        30.844
                                                    ],
                                                    [
                                                        -2.169,
                                                        30.844
                                                    ],
                                                    [
                                                        -3.654,
                                                        32.333
                                                    ],
                                                    [
                                                        -3.76,
                                                        29.417
                                                    ],
                                                    [
                                                        -2.275,
                                                        30.906
                                                    ],
                                                    [
                                                        2.276,
                                                        30.906
                                                    ],
                                                    [
                                                        3.76,
                                                        29.417
                                                    ],
                                                    [
                                                        3.865,
                                                        32.333
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 52
                                    },
                                    {
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0.822
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0.82,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        -0.822
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        2.276,
                                                        -30.906
                                                    ],
                                                    [
                                                        -2.275,
                                                        -30.906
                                                    ],
                                                    [
                                                        -3.76,
                                                        -29.417
                                                    ],
                                                    [
                                                        -3.76,
                                                        29.417
                                                    ],
                                                    [
                                                        -2.275,
                                                        30.906
                                                    ],
                                                    [
                                                        2.276,
                                                        30.906
                                                    ],
                                                    [
                                                        3.76,
                                                        29.417
                                                    ],
                                                    [
                                                        3.76,
                                                        -29.417
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 119
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    4.009,
                                    31.156
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 10
        },
        {
            ty: 4,
            nm: 'Layer 12 Outlines 3',
            sr: 1,
            st: 74,
            op: 289,
            ip: 80,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        15.139,
                        34.419,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        -63.5214,
                        1088.7523
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        48.3858,
                        39.2624
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [],
            ind: 11
        },
        {
            ty: 4,
            nm: 'Layer 12 Outlines 6',
            sr: 1,
            st: 84,
            op: 299,
            ip: 90,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        1.139,
                        42.419,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        48.3858,
                        39.2624
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 2,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -20.326,
                                                        10.544
                                                    ],
                                                    [
                                                        -20.299,
                                                        10.331
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 90
                                    },
                                    {
                                        s: [
                                            {
                                                c: false,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -20.219,
                                                        10.171
                                                    ],
                                                    [
                                                        -5.893,
                                                        -3.06
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 117
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 10,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    -15,
                                    8
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    98.915,
                                    99.894
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    31.139,
                                    23.419
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 12
        },
        {
            ty: 4,
            nm: 'Layer 12 Outlines 5',
            sr: 1,
            st: 54,
            op: 269,
            ip: 60,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        15.139,
                        34.419,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        48.3858,
                        39.2624
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 2,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -20.326,
                                                        10.544
                                                    ],
                                                    [
                                                        -20.299,
                                                        10.331
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 60
                                    },
                                    {
                                        s: [
                                            {
                                                c: false,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -20.219,
                                                        10.234
                                                    ],
                                                    [
                                                        -5.64,
                                                        2.383
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 87
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 10,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    -15,
                                    8
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    98.915,
                                    99.894
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    31.139,
                                    23.419
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 13
        },
        {
            ty: 4,
            nm: 'Layer 12 Outlines 2',
            sr: 1,
            st: 27,
            op: 242,
            ip: 33,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        15.139,
                        34.419,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        48.3858,
                        39.2624
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 2,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: true,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -20.326,
                                                        10.544
                                                    ],
                                                    [
                                                        -20.299,
                                                        10.331
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 33
                                    },
                                    {
                                        s: [
                                            {
                                                c: false,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -20.219,
                                                        10.234
                                                    ],
                                                    [
                                                        -5.64,
                                                        2.383
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 60
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 10,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    98.915,
                                    99.894
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    31.139,
                                    23.419
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 14
        },
        {
            ty: 4,
            nm: 'Layer 12 Outlines',
            sr: 1,
            st: 3,
            op: 218,
            ip: 9,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        27.139,
                        23.419,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        48.3858,
                        39.2624
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 2,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 1,
                                k: [
                                    {
                                        o: {
                                            x: 0.167,
                                            y: 0.167
                                        },
                                        i: {
                                            x: 0.833,
                                            y: 0.833
                                        },
                                        s: [
                                            {
                                                c: false,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -22.326,
                                                        11.794
                                                    ],
                                                    [
                                                        -22.174,
                                                        11.456
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 9
                                    },
                                    {
                                        s: [
                                            {
                                                c: false,
                                                i: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                o: [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                v: [
                                                    [
                                                        -22.341,
                                                        11.734
                                                    ],
                                                    [
                                                        -8.23,
                                                        -0.519
                                                    ]
                                                ]
                                            }
                                        ],
                                        t: 36
                                    }
                                ],
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 10,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    31.139,
                                    23.419
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 15
        },
        {
            ty: 4,
            nm: 'Layer 13 Outlines',
            sr: 1,
            st: 0,
            op: 360,
            ip: 360,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        29.087,
                        17.682,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        54.2648,
                        58.1591
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -24.001,
                                            -34.864
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -32.837,
                                            17.432
                                        ],
                                        [
                                            32.837,
                                            17.432
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    33.087,
                                    17.682
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 16
        },
        {
            ty: 4,
            nm: 'Layer 11 Outlines',
            sr: 1,
            st: 0,
            op: 360,
            ip: 360,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        15.58,
                        33.378,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        83.9631,
                        83.9631
                    ],
                    ix: 6
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        84.1347,
                        62.5176
                    ],
                    ix: 2
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                }
            },
            shapes: [
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 1',
                    ix: 1,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.079,
                                            -1.498
                                        ],
                                        [
                                            0.157,
                                            -0.394
                                        ],
                                        [
                                            0.079,
                                            0.394
                                        ],
                                        [
                                            -0.06,
                                            0.717
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.079,
                                            1.498
                                        ],
                                        [
                                            -0.157,
                                            0.394
                                        ],
                                        [
                                            -0.078,
                                            -0.395
                                        ],
                                        [
                                            0.061,
                                            -0.716
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -0.904,
                                            -11.311
                                        ],
                                        [
                                            0.277,
                                            -10.996
                                        ],
                                        [
                                            1.141,
                                            -0.749
                                        ],
                                        [
                                            2.006,
                                            10.365
                                        ],
                                        [
                                            -0.669,
                                            10.917
                                        ],
                                        [
                                            -1.829,
                                            0.913
                                        ],
                                        [
                                            -2.163,
                                            -7.212
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    30.172,
                                    23.485
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 2',
                    ix: 2,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0.786,
                                            -0.157
                                        ],
                                        [
                                            0.58,
                                            -0.089
                                        ],
                                        [
                                            -0.05,
                                            0.606
                                        ],
                                        [
                                            -0.017,
                                            1.62
                                        ],
                                        [
                                            -0.308,
                                            -1.002
                                        ]
                                    ],
                                    o: [
                                        [
                                            -0.183,
                                            0.036
                                        ],
                                        [
                                            -0.302,
                                            -2.232
                                        ],
                                        [
                                            0.026,
                                            -0.297
                                        ],
                                        [
                                            0.042,
                                            1.591
                                        ],
                                        [
                                            0.628,
                                            2.05
                                        ]
                                    ],
                                    v: [
                                        [
                                            1.039,
                                            6.124
                                        ],
                                        [
                                            -0.168,
                                            6.323
                                        ],
                                        [
                                            -1.224,
                                            -2.934
                                        ],
                                        [
                                            -1.16,
                                            -6.323
                                        ],
                                        [
                                            -0.691,
                                            -1.916
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    29.253,
                                    27.332
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 3',
                    ix: 3,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.06,
                                            -0.668
                                        ],
                                        [
                                            0.213,
                                            -0.389
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            -0.538,
                                            1.412
                                        ],
                                        [
                                            0.006,
                                            -1.008
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            1.056,
                                            -1.608
                                        ],
                                        [
                                            -1.056,
                                            2.693
                                        ],
                                        [
                                            -1.047,
                                            0.972
                                        ],
                                        [
                                            0.605,
                                            -2.418
                                        ],
                                        [
                                            0.958,
                                            -2.693
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    29.175,
                                    15.183
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 4',
                    ix: 4,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.079,
                                            -1.025
                                        ],
                                        [
                                            -1.337,
                                            0
                                        ],
                                        [
                                            0.235,
                                            0.552
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.078,
                                            1.025
                                        ],
                                        [
                                            1.336,
                                            0
                                        ],
                                        [
                                            -0.237,
                                            -0.552
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            0.314,
                                            -11.114
                                        ],
                                        [
                                            -0.236,
                                            -10.641
                                        ],
                                        [
                                            -0.865,
                                            -5.439
                                        ],
                                        [
                                            -1.179,
                                            11.114
                                        ],
                                        [
                                            1.416,
                                            10.326
                                        ],
                                        [
                                            1.808,
                                            0.43
                                        ],
                                        [
                                            2.516,
                                            -7.803
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    15.429,
                                    23.84
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 5',
                    ix: 5,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.079,
                                            -1.849
                                        ],
                                        [
                                            -0.025,
                                            0.152
                                        ],
                                        [
                                            0,
                                            0.867
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.424,
                                            -0.122
                                        ],
                                        [
                                            0.079,
                                            -0.473
                                        ],
                                        [
                                            0,
                                            -0.867
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.037,
                                            -0.22
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            0.697,
                                            0.774
                                        ],
                                        [
                                            0.26,
                                            10.297
                                        ],
                                        [
                                            -0.403,
                                            9.881
                                        ],
                                        [
                                            0.541,
                                            -0.445
                                        ],
                                        [
                                            0.855,
                                            -5.489
                                        ],
                                        [
                                            -1.405,
                                            -9.947
                                        ],
                                        [
                                            -1.347,
                                            -10.297
                                        ],
                                        [
                                            -0.206,
                                            -7.893
                                        ],
                                        [
                                            1.406,
                                            -7.46
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    16.776,
                                    23.496
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 6',
                    ix: 6,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.494,
                                            -0.631
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.494,
                                            0.631
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            0.315,
                                            -2.759
                                        ],
                                        [
                                            0,
                                            2.128
                                        ],
                                        [
                                            -1.022,
                                            -2.602
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    15.744,
                                    36.689
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 7',
                    ix: 7,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0.13,
                                            0.792
                                        ],
                                        [
                                            0.151,
                                            0.209
                                        ],
                                        [
                                            0.309,
                                            0.49
                                        ],
                                        [
                                            0.209,
                                            0.153
                                        ],
                                        [
                                            0.276,
                                            -0.009
                                        ],
                                        [
                                            0.081,
                                            -0.004
                                        ],
                                        [
                                            0.053,
                                            0.014
                                        ],
                                        [
                                            0.016,
                                            -0.014
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.098,
                                            0.011
                                        ],
                                        [
                                            0.036,
                                            0.102
                                        ],
                                        [
                                            0.043,
                                            -0.099
                                        ],
                                        [
                                            0.098,
                                            -0.001
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.038,
                                            -0.037
                                        ],
                                        [
                                            0.053,
                                            -0.011
                                        ],
                                        [
                                            0.089,
                                            -0.014
                                        ],
                                        [
                                            0.007,
                                            0
                                        ],
                                        [
                                            0.401,
                                            -0.264
                                        ],
                                        [
                                            0.104,
                                            -0.203
                                        ],
                                        [
                                            0.048,
                                            -0.035
                                        ],
                                        [
                                            0.111,
                                            -0.16
                                        ],
                                        [
                                            0.04,
                                            -0.156
                                        ],
                                        [
                                            -0.014,
                                            -0.491
                                        ],
                                        [
                                            -0.325,
                                            -0.373
                                        ],
                                        [
                                            -0.206,
                                            -0.222
                                        ],
                                        [
                                            -0.364,
                                            -0.483
                                        ],
                                        [
                                            -0.615,
                                            -0.096
                                        ],
                                        [
                                            -0.363,
                                            0.09
                                        ],
                                        [
                                            -0.301,
                                            0.224
                                        ],
                                        [
                                            -0.093,
                                            0.149
                                        ],
                                        [
                                            -0.079,
                                            0.421
                                        ]
                                    ],
                                    o: [
                                        [
                                            -0.056,
                                            -0.251
                                        ],
                                        [
                                            -0.059,
                                            -0.576
                                        ],
                                        [
                                            -0.121,
                                            -0.229
                                        ],
                                        [
                                            -0.24,
                                            -0.139
                                        ],
                                        [
                                            -0.051,
                                            0
                                        ],
                                        [
                                            -0.052,
                                            -0.017
                                        ],
                                        [
                                            -0.031,
                                            -0.068
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.097,
                                            -0.017
                                        ],
                                        [
                                            -0.036,
                                            -0.101
                                        ],
                                        [
                                            -0.058,
                                            0.091
                                        ],
                                        [
                                            -0.096,
                                            -0.005
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.011,
                                            0.052
                                        ],
                                        [
                                            -0.038,
                                            0.038
                                        ],
                                        [
                                            -0.09,
                                            0.009
                                        ],
                                        [
                                            -0.008,
                                            0
                                        ],
                                        [
                                            -0.48,
                                            -0.012
                                        ],
                                        [
                                            -0.188,
                                            0.129
                                        ],
                                        [
                                            -0.049,
                                            0.033
                                        ],
                                        [
                                            -0.161,
                                            0.11
                                        ],
                                        [
                                            -0.08,
                                            0.139
                                        ],
                                        [
                                            -0.153,
                                            0.467
                                        ],
                                        [
                                            0.017,
                                            0.496
                                        ],
                                        [
                                            0.206,
                                            0.221
                                        ],
                                        [
                                            0.425,
                                            0.456
                                        ],
                                        [
                                            0.383,
                                            0.51
                                        ],
                                        [
                                            0.37,
                                            0.056
                                        ],
                                        [
                                            0.363,
                                            -0.091
                                        ],
                                        [
                                            0.145,
                                            -0.101
                                        ],
                                        [
                                            0.214,
                                            -0.371
                                        ],
                                        [
                                            0.15,
                                            -0.787
                                        ]
                                    ],
                                    v: [
                                        [
                                            3.55,
                                            -0.46
                                        ],
                                        [
                                            3.238,
                                            -1.157
                                        ],
                                        [
                                            2.678,
                                            -2.778
                                        ],
                                        [
                                            2.176,
                                            -3.359
                                        ],
                                        [
                                            1.386,
                                            -3.557
                                        ],
                                        [
                                            1.164,
                                            -3.538
                                        ],
                                        [
                                            1.007,
                                            -3.583
                                        ],
                                        [
                                            0.899,
                                            -3.837
                                        ],
                                        [
                                            0.669,
                                            -3.654
                                        ],
                                        [
                                            0.377,
                                            -3.695
                                        ],
                                        [
                                            0.27,
                                            -4
                                        ],
                                        [
                                            0.118,
                                            -3.715
                                        ],
                                        [
                                            -0.174,
                                            -3.72
                                        ],
                                        [
                                            -0.369,
                                            -3.907
                                        ],
                                        [
                                            -0.445,
                                            -3.77
                                        ],
                                        [
                                            -0.584,
                                            -3.696
                                        ],
                                        [
                                            -0.851,
                                            -3.661
                                        ],
                                        [
                                            -0.873,
                                            -3.661
                                        ],
                                        [
                                            -2.271,
                                            -3.43
                                        ],
                                        [
                                            -2.716,
                                            -2.924
                                        ],
                                        [
                                            -2.862,
                                            -2.822
                                        ],
                                        [
                                            -3.274,
                                            -2.413
                                        ],
                                        [
                                            -3.456,
                                            -1.97
                                        ],
                                        [
                                            -3.666,
                                            -0.522
                                        ],
                                        [
                                            -3.138,
                                            0.821
                                        ],
                                        [
                                            -2.465,
                                            1.428
                                        ],
                                        [
                                            -1.597,
                                            3.002
                                        ],
                                        [
                                            0.103,
                                            3.944
                                        ],
                                        [
                                            1.213,
                                            3.892
                                        ],
                                        [
                                            2.218,
                                            3.415
                                        ],
                                        [
                                            2.578,
                                            3.037
                                        ],
                                        [
                                            2.78,
                                            1.78
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    23.001,
                                    4.25
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 8',
                    ix: 8,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0.786,
                                            -0.157
                                        ],
                                        [
                                            0.58,
                                            -0.089
                                        ],
                                        [
                                            0.122,
                                            0.304
                                        ],
                                        [
                                            0.393,
                                            -0.63
                                        ],
                                        [
                                            1.652,
                                            -0.079
                                        ],
                                        [
                                            0.904,
                                            0.26
                                        ],
                                        [
                                            -0.025,
                                            0.151
                                        ],
                                        [
                                            0,
                                            0.867
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.708,
                                            0.158
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.336,
                                            -0.079
                                        ],
                                        [
                                            -1.808,
                                            -1.498
                                        ],
                                        [
                                            -0.786,
                                            -0.473
                                        ],
                                        [
                                            -0.079,
                                            -0.788
                                        ],
                                        [
                                            0.148,
                                            -0.386
                                        ],
                                        [
                                            0.213,
                                            -0.389
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.043,
                                            -1.659
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.308,
                                            -1.002
                                        ]
                                    ],
                                    o: [
                                        [
                                            -0.183,
                                            0.036
                                        ],
                                        [
                                            -1.933,
                                            0.292
                                        ],
                                        [
                                            -0.157,
                                            -0.395
                                        ],
                                        [
                                            -0.393,
                                            0.631
                                        ],
                                        [
                                            -1.123,
                                            0.054
                                        ],
                                        [
                                            -0.425,
                                            -0.122
                                        ],
                                        [
                                            0.078,
                                            -0.474
                                        ],
                                        [
                                            0,
                                            -0.867
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.708,
                                            -0.157
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.336,
                                            0.079
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.786,
                                            0.473
                                        ],
                                        [
                                            0.016,
                                            0.158
                                        ],
                                        [
                                            -0.538,
                                            1.412
                                        ],
                                        [
                                            -0.018,
                                            0.034
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.043,
                                            1.592
                                        ],
                                        [
                                            0.628,
                                            2.05
                                        ]
                                    ],
                                    v: [
                                        [
                                            7.156,
                                            11.986
                                        ],
                                        [
                                            5.949,
                                            12.186
                                        ],
                                        [
                                            0.471,
                                            12.618
                                        ],
                                        [
                                            -0.629,
                                            11.435
                                        ],
                                        [
                                            -2.438,
                                            12.697
                                        ],
                                        [
                                            -6.099,
                                            12.325
                                        ],
                                        [
                                            -6.762,
                                            11.909
                                        ],
                                        [
                                            -5.819,
                                            1.583
                                        ],
                                        [
                                            -5.504,
                                            -3.462
                                        ],
                                        [
                                            -7.764,
                                            -7.919
                                        ],
                                        [
                                            -7.942,
                                            -8.271
                                        ],
                                        [
                                            -6.998,
                                            -9.296
                                        ],
                                        [
                                            -2.909,
                                            -11.424
                                        ],
                                        [
                                            -0.865,
                                            -12.449
                                        ],
                                        [
                                            2.594,
                                            -11.424
                                        ],
                                        [
                                            5.583,
                                            -10.005
                                        ],
                                        [
                                            7.313,
                                            -8.743
                                        ],
                                        [
                                            7.095,
                                            -7.895
                                        ],
                                        [
                                            4.983,
                                            -3.594
                                        ],
                                        [
                                            4.954,
                                            -3.542
                                        ],
                                        [
                                            4.956,
                                            -0.465
                                        ],
                                        [
                                            4.956,
                                            -0.46
                                        ],
                                        [
                                            5.426,
                                            3.947
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    23.135,
                                    21.47
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 9',
                    ix: 9,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.266,
                                            -1.892
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -2.165,
                                            0.664
                                        ],
                                        [
                                            2.018,
                                            0.664
                                        ],
                                        [
                                            2.165,
                                            1.228
                                        ],
                                        [
                                            0.982,
                                            1.216
                                        ],
                                        [
                                            -2.165,
                                            1.216
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    23.098,
                                    8.594
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 10',
                    ix: 10,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.237,
                                            -0.078
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.865,
                                            1.813
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.235,
                                            0.079
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -2.202,
                                            -1.853
                                        ],
                                        [
                                            -1.967,
                                            2.01
                                        ],
                                        [
                                            2.202,
                                            2.01
                                        ],
                                        [
                                            2.202,
                                            -2.089
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    23.135,
                                    8.036
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 11',
                    ix: 11,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -1.52,
                                            0
                                        ],
                                        [
                                            0,
                                            1.524
                                        ],
                                        [
                                            1.521,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.523
                                        ]
                                    ],
                                    o: [
                                        [
                                            1.521,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.523
                                        ],
                                        [
                                            -1.52,
                                            0
                                        ],
                                        [
                                            0,
                                            1.524
                                        ]
                                    ],
                                    v: [
                                        [
                                            0,
                                            2.759
                                        ],
                                        [
                                            2.752,
                                            0
                                        ],
                                        [
                                            0,
                                            -2.759
                                        ],
                                        [
                                            -2.752,
                                            0
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    22.978,
                                    4.922
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 12',
                    ix: 12,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.315,
                                            -0.631
                                        ],
                                        [
                                            0.158,
                                            -0.631
                                        ],
                                        [
                                            -0.943,
                                            -0.394
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.236,
                                            1.655
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.101,
                                            -1.892
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.315,
                                            0.079
                                        ],
                                        [
                                            -0.237,
                                            1.341
                                        ],
                                        [
                                            -0.472,
                                            1.813
                                        ],
                                        [
                                            1.966,
                                            2.049
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.314,
                                            0.631
                                        ],
                                        [
                                            -0.157,
                                            0.631
                                        ],
                                        [
                                            0.944,
                                            0.394
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.236,
                                            -1.656
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.101,
                                            1.891
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.314,
                                            -0.079
                                        ],
                                        [
                                            0.236,
                                            -1.34
                                        ],
                                        [
                                            0.472,
                                            -1.812
                                        ],
                                        [
                                            -1.966,
                                            -2.05
                                        ]
                                    ],
                                    v: [
                                        [
                                            -6.369,
                                            -13.557
                                        ],
                                        [
                                            -6.604,
                                            -0.473
                                        ],
                                        [
                                            -5.348,
                                            11.429
                                        ],
                                        [
                                            -5.348,
                                            15.055
                                        ],
                                        [
                                            -2.359,
                                            15.055
                                        ],
                                        [
                                            -2.044,
                                            10.247
                                        ],
                                        [
                                            -2.359,
                                            1.655
                                        ],
                                        [
                                            -0.786,
                                            -5.596
                                        ],
                                        [
                                            -0.236,
                                            1.261
                                        ],
                                        [
                                            -1.18,
                                            12.533
                                        ],
                                        [
                                            -0.786,
                                            15.213
                                        ],
                                        [
                                            2.516,
                                            15.528
                                        ],
                                        [
                                            2.516,
                                            11.035
                                        ],
                                        [
                                            3.775,
                                            0.394
                                        ],
                                        [
                                            4.954,
                                            -13.557
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    23.607,
                                    46.383
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 13',
                    ix: 13,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.393,
                                            -0.236
                                        ],
                                        [
                                            -0.136,
                                            -0.013
                                        ],
                                        [
                                            -0.129,
                                            0.044
                                        ],
                                        [
                                            0.629,
                                            -0.867
                                        ],
                                        [
                                            0,
                                            -0.393
                                        ],
                                        [
                                            0.079,
                                            0.395
                                        ],
                                        [
                                            -0.157,
                                            0.078
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.117,
                                            0.07
                                        ],
                                        [
                                            0.135,
                                            0.014
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.629,
                                            0.867
                                        ],
                                        [
                                            0,
                                            0.395
                                        ],
                                        [
                                            -0.078,
                                            -0.393
                                        ],
                                        [
                                            0.157,
                                            -0.079
                                        ]
                                    ],
                                    v: [
                                        [
                                            -1.651,
                                            -1.419
                                        ],
                                        [
                                            -0.157,
                                            -1.262
                                        ],
                                        [
                                            0.228,
                                            -1.137
                                        ],
                                        [
                                            0.629,
                                            -1.182
                                        ],
                                        [
                                            1.73,
                                            -0.473
                                        ],
                                        [
                                            0.472,
                                            1.103
                                        ],
                                        [
                                            -2.202,
                                            1.103
                                        ],
                                        [
                                            -2.202,
                                            -1.419
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    25.022,
                                    62.384
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 14',
                    ix: 14,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.392,
                                            -0.236
                                        ],
                                        [
                                            0.136,
                                            -0.013
                                        ],
                                        [
                                            0.129,
                                            0.044
                                        ],
                                        [
                                            -0.629,
                                            -0.867
                                        ],
                                        [
                                            0,
                                            -0.393
                                        ],
                                        [
                                            -0.078,
                                            0.395
                                        ],
                                        [
                                            0.157,
                                            0.078
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.118,
                                            0.07
                                        ],
                                        [
                                            -0.136,
                                            0.014
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.629,
                                            0.867
                                        ],
                                        [
                                            0,
                                            0.395
                                        ],
                                        [
                                            0.079,
                                            -0.393
                                        ],
                                        [
                                            -0.157,
                                            -0.079
                                        ]
                                    ],
                                    v: [
                                        [
                                            1.652,
                                            -1.419
                                        ],
                                        [
                                            0.158,
                                            -1.262
                                        ],
                                        [
                                            -0.227,
                                            -1.137
                                        ],
                                        [
                                            -0.628,
                                            -1.182
                                        ],
                                        [
                                            -1.73,
                                            -0.473
                                        ],
                                        [
                                            -0.471,
                                            1.103
                                        ],
                                        [
                                            2.202,
                                            1.103
                                        ],
                                        [
                                            2.202,
                                            -1.419
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    18.81,
                                    62.384
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 15',
                    ix: 15,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.494,
                                            -0.631
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.494,
                                            0.63
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            0.315,
                                            -2.759
                                        ],
                                        [
                                            0,
                                            2.129
                                        ],
                                        [
                                            -1.022,
                                            -2.601
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    30.841,
                                    36.451
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 16',
                    ix: 16,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0.416,
                                            -0.004
                                        ],
                                        [
                                            0.515,
                                            0.316
                                        ],
                                        [
                                            0.053,
                                            0.397
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.516,
                                            -0.315
                                        ],
                                        [
                                            -1.939,
                                            0.016
                                        ],
                                        [
                                            0.01,
                                            0.296
                                        ]
                                    ],
                                    o: [
                                        [
                                            -1.938,
                                            0.016
                                        ],
                                        [
                                            -0.395,
                                            -0.24
                                        ],
                                        [
                                            -0.036,
                                            0.001
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.517,
                                            0.315
                                        ],
                                        [
                                            0.56,
                                            -0.005
                                        ],
                                        [
                                            -0.078,
                                            0.179
                                        ]
                                    ],
                                    v: [
                                        [
                                            2.487,
                                            0.572
                                        ],
                                        [
                                            -2.534,
                                            0.575
                                        ],
                                        [
                                            -3.138,
                                            -0.924
                                        ],
                                        [
                                            -3.195,
                                            -0.922
                                        ],
                                        [
                                            -2.57,
                                            0.782
                                        ],
                                        [
                                            2.452,
                                            0.778
                                        ],
                                        [
                                            3.195,
                                            0.278
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    33.731,
                                    44.89
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 17',
                    ix: 17,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.517,
                                            0.369
                                        ],
                                        [
                                            -0.128,
                                            -0.591
                                        ],
                                        [
                                            1.94,
                                            -0.015
                                        ],
                                        [
                                            0.517,
                                            0.316
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.518,
                                            -0.37
                                        ],
                                        [
                                            0.129,
                                            0.593
                                        ],
                                        [
                                            -1.938,
                                            0.016
                                        ],
                                        [
                                            -0.517,
                                            -0.315
                                        ]
                                    ],
                                    v: [
                                        [
                                            -3.793,
                                            -0.083
                                        ],
                                        [
                                            -1.559,
                                            -1.127
                                        ],
                                        [
                                            1.212,
                                            -1.346
                                        ],
                                        [
                                            1.853,
                                            1.617
                                        ],
                                        [
                                            -3.168,
                                            1.621
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    34.329,
                                    44.051
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 18',
                    ix: 18,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.054,
                                            -0.305
                                        ],
                                        [
                                            -0.338,
                                            -0.293
                                        ],
                                        [
                                            -0.447,
                                            -0.015
                                        ],
                                        [
                                            -0.356,
                                            0.27
                                        ],
                                        [
                                            -0.108,
                                            0.434
                                        ],
                                        [
                                            0.19,
                                            0.404
                                        ],
                                        [
                                            0.402,
                                            0.195
                                        ],
                                        [
                                            0.434,
                                            -0.103
                                        ],
                                        [
                                            0.273,
                                            -0.355
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.077,
                                            0.44
                                        ],
                                        [
                                            0.337,
                                            0.294
                                        ],
                                        [
                                            0.445,
                                            0.015
                                        ],
                                        [
                                            0.356,
                                            -0.27
                                        ],
                                        [
                                            0.106,
                                            -0.435
                                        ],
                                        [
                                            -0.19,
                                            -0.404
                                        ],
                                        [
                                            -0.402,
                                            -0.194
                                        ],
                                        [
                                            -0.435,
                                            0.103
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.093,
                                            0.296
                                        ]
                                    ],
                                    v: [
                                        [
                                            -1.929,
                                            0.356
                                        ],
                                        [
                                            -1.288,
                                            1.49
                                        ],
                                        [
                                            -0.077,
                                            1.967
                                        ],
                                        [
                                            1.161,
                                            1.573
                                        ],
                                        [
                                            1.877,
                                            0.484
                                        ],
                                        [
                                            1.747,
                                            -0.813
                                        ],
                                        [
                                            0.831,
                                            -1.739
                                        ],
                                        [
                                            -0.461,
                                            -1.879
                                        ],
                                        [
                                            -1.554,
                                            -1.172
                                        ],
                                        [
                                            -0.687,
                                            0.136
                                        ],
                                        [
                                            -1.87,
                                            -0.558
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    34.361,
                                    38.553
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 19',
                    ix: 19,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.24,
                                            -0.087
                                        ],
                                        [
                                            -0.445,
                                            0.177
                                        ],
                                        [
                                            -0.214,
                                            0.429
                                        ],
                                        [
                                            0.126,
                                            0.462
                                        ],
                                        [
                                            0.401,
                                            0.261
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.001,
                                            0.001
                                        ],
                                        [
                                            0.255,
                                            -0.011
                                        ],
                                        [
                                            0.232,
                                            -0.109
                                        ],
                                        [
                                            0.171,
                                            -0.19
                                        ],
                                        [
                                            0.088,
                                            -0.241
                                        ],
                                        [
                                            -0.012,
                                            -0.256
                                        ],
                                        [
                                            -0.107,
                                            -0.231
                                        ],
                                        [
                                            -0.189,
                                            -0.172
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.449,
                                            0.163
                                        ],
                                        [
                                            0.443,
                                            -0.178
                                        ],
                                        [
                                            0.213,
                                            -0.429
                                        ],
                                        [
                                            -0.126,
                                            -0.462
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.001,
                                            -0.001
                                        ],
                                        [
                                            -0.241,
                                            -0.087
                                        ],
                                        [
                                            -0.255,
                                            0.012
                                        ],
                                        [
                                            -0.232,
                                            0.109
                                        ],
                                        [
                                            -0.173,
                                            0.189
                                        ],
                                        [
                                            -0.087,
                                            0.24
                                        ],
                                        [
                                            0.01,
                                            0.256
                                        ],
                                        [
                                            0.109,
                                            0.233
                                        ],
                                        [
                                            0.188,
                                            0.173
                                        ]
                                    ],
                                    v: [
                                        [
                                            -0.688,
                                            1.816
                                        ],
                                        [
                                            0.699,
                                            1.794
                                        ],
                                        [
                                            1.719,
                                            0.851
                                        ],
                                        [
                                            1.854,
                                            -0.533
                                        ],
                                        [
                                            1.036,
                                            -1.656
                                        ],
                                        [
                                            0.807,
                                            -0.885
                                        ],
                                        [
                                            0.645,
                                            -1.85
                                        ],
                                        [
                                            0.641,
                                            -1.852
                                        ],
                                        [
                                            -0.111,
                                            -1.967
                                        ],
                                        [
                                            -0.848,
                                            -1.786
                                        ],
                                        [
                                            -1.46,
                                            -1.335
                                        ],
                                        [
                                            -1.854,
                                            -0.684
                                        ],
                                        [
                                            -1.967,
                                            0.068
                                        ],
                                        [
                                            -1.788,
                                            0.808
                                        ],
                                        [
                                            -1.337,
                                            1.421
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    35.146,
                                    33.853
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 20',
                    ix: 20,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.142,
                                            0.389
                                        ],
                                        [
                                            -0.245,
                                            0.217
                                        ],
                                        [
                                            -0.317,
                                            0.071
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.329,
                                            -0.248
                                        ],
                                        [
                                            -0.119,
                                            -0.396
                                        ],
                                        [
                                            0.136,
                                            -0.391
                                        ],
                                        [
                                            0.338,
                                            -0.235
                                        ],
                                        [
                                            0.413,
                                            0.011
                                        ],
                                        [
                                            0.327,
                                            0.253
                                        ],
                                        [
                                            0.115,
                                            0.397
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.11,
                                            -0.308
                                        ],
                                        [
                                            0.245,
                                            -0.216
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.414,
                                            0.006
                                        ],
                                        [
                                            0.33,
                                            0.249
                                        ],
                                        [
                                            0.12,
                                            0.395
                                        ],
                                        [
                                            -0.136,
                                            0.39
                                        ],
                                        [
                                            -0.34,
                                            0.235
                                        ],
                                        [
                                            -0.411,
                                            -0.011
                                        ],
                                        [
                                            -0.327,
                                            -0.253
                                        ],
                                        [
                                            -0.115,
                                            -0.397
                                        ]
                                    ],
                                    v: [
                                        [
                                            -1.828,
                                            -0.671
                                        ],
                                        [
                                            -1.285,
                                            -1.469
                                        ],
                                        [
                                            -0.428,
                                            -1.908
                                        ],
                                        [
                                            -0.268,
                                            -0.954
                                        ],
                                        [
                                            0.029,
                                            -1.956
                                        ],
                                        [
                                            1.172,
                                            -1.564
                                        ],
                                        [
                                            1.863,
                                            -0.572
                                        ],
                                        [
                                            1.839,
                                            0.639
                                        ],
                                        [
                                            1.107,
                                            1.6
                                        ],
                                        [
                                            -0.053,
                                            1.945
                                        ],
                                        [
                                            -1.188,
                                            1.538
                                        ],
                                        [
                                            -1.867,
                                            0.538
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    34.829,
                                    26.027
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 21',
                    ix: 21,
                    cix: 2,
                    np: 2,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: false,
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.715,
                                            0.493
                                        ],
                                        [
                                            -0.245,
                                            0.836
                                        ],
                                        [
                                            0.814,
                                            0.948
                                        ],
                                        [
                                            0.421,
                                            0.826
                                        ],
                                        [
                                            0.062,
                                            0.368
                                        ],
                                        [
                                            -0.172,
                                            0.507
                                        ],
                                        [
                                            -0.653,
                                            1.662
                                        ]
                                    ],
                                    o: [
                                        [
                                            -0.167,
                                            -0.854
                                        ],
                                        [
                                            0.716,
                                            -0.492
                                        ],
                                        [
                                            0.352,
                                            -1.2
                                        ],
                                        [
                                            -0.604,
                                            -0.703
                                        ],
                                        [
                                            -0.184,
                                            -0.324
                                        ],
                                        [
                                            -0.063,
                                            -0.532
                                        ],
                                        [
                                            0.571,
                                            -1.692
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -1.503,
                                            8.553
                                        ],
                                        [
                                            -0.23,
                                            6.451
                                        ],
                                        [
                                            1.568,
                                            4.639
                                        ],
                                        [
                                            0.06,
                                            1.393
                                        ],
                                        [
                                            -1.486,
                                            -0.91
                                        ],
                                        [
                                            -1.857,
                                            -1.956
                                        ],
                                        [
                                            -1.577,
                                            -3.525
                                        ],
                                        [
                                            0.258,
                                            -8.553
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'st',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Stroke',
                            nm: 'Stroke 1',
                            lc: 1,
                            lj: 1,
                            ml: 10,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 1,
                                ix: 5
                            },
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 3
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    34.741,
                                    34.257
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 22',
                    ix: 22,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -0.397,
                                            -0.145
                                        ],
                                        [
                                            -0.3,
                                            0.035
                                        ],
                                        [
                                            -0.253,
                                            0.164
                                        ],
                                        [
                                            -0.153,
                                            0.261
                                        ],
                                        [
                                            -0.021,
                                            0.302
                                        ],
                                        [
                                            0.115,
                                            0.279
                                        ],
                                        [
                                            0.228,
                                            0.199
                                        ],
                                        [
                                            0.292,
                                            0.076
                                        ],
                                        [
                                            0.296,
                                            -0.064
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.175,
                                            -0.484
                                        ],
                                        [
                                            0.011,
                                            -0.18
                                        ],
                                        [
                                            -0.23,
                                            -0.356
                                        ]
                                    ],
                                    o: [
                                        [
                                            0.283,
                                            0.104
                                        ],
                                        [
                                            0.3,
                                            -0.035
                                        ],
                                        [
                                            0.252,
                                            -0.165
                                        ],
                                        [
                                            0.153,
                                            -0.26
                                        ],
                                        [
                                            0.02,
                                            -0.302
                                        ],
                                        [
                                            -0.115,
                                            -0.279
                                        ],
                                        [
                                            -0.228,
                                            -0.198
                                        ],
                                        [
                                            -0.292,
                                            -0.075
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.465,
                                            0.219
                                        ],
                                        [
                                            -0.062,
                                            0.17
                                        ],
                                        [
                                            -0.031,
                                            0.423
                                        ],
                                        [
                                            0.231,
                                            0.356
                                        ]
                                    ],
                                    v: [
                                        [
                                            -0.66,
                                            1.833
                                        ],
                                        [
                                            0.227,
                                            1.938
                                        ],
                                        [
                                            1.067,
                                            1.635
                                        ],
                                        [
                                            1.682,
                                            0.988
                                        ],
                                        [
                                            1.947,
                                            0.135
                                        ],
                                        [
                                            1.803,
                                            -0.749
                                        ],
                                        [
                                            1.281,
                                            -1.475
                                        ],
                                        [
                                            0.491,
                                            -1.891
                                        ],
                                        [
                                            -0.401,
                                            -1.909
                                        ],
                                        [
                                            -0.351,
                                            -0.905
                                        ],
                                        [
                                            -0.826,
                                            -1.766
                                        ],
                                        [
                                            -1.825,
                                            -0.667
                                        ],
                                        [
                                            -1.936,
                                            -0.139
                                        ],
                                        [
                                            -1.628,
                                            1.061
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    31.553,
                                    29.332
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                },
                {
                    ty: 'gr',
                    bm: 0,
                    hd: false,
                    mn: 'ADBE Vector Group',
                    nm: 'Group 23',
                    ix: 23,
                    cix: 2,
                    np: 4,
                    it: [
                        {
                            ty: 'sh',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Shape - Group',
                            nm: 'Path 1',
                            ix: 1,
                            d: 1,
                            ks: {
                                a: 0,
                                k: {
                                    c: true,
                                    i: [
                                        [
                                            -10.66,
                                            0
                                        ],
                                        [
                                            0,
                                            1.665
                                        ],
                                        [
                                            10.66,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.665
                                        ]
                                    ],
                                    o: [
                                        [
                                            10.66,
                                            0
                                        ],
                                        [
                                            0,
                                            -1.665
                                        ],
                                        [
                                            -10.66,
                                            0
                                        ],
                                        [
                                            0,
                                            1.665
                                        ]
                                    ],
                                    v: [
                                        [
                                            0.001,
                                            3.016
                                        ],
                                        [
                                            19.301,
                                            0
                                        ],
                                        [
                                            0.001,
                                            -3.015
                                        ],
                                        [
                                            -19.301,
                                            0
                                        ]
                                    ]
                                },
                                ix: 2
                            }
                        },
                        {
                            ty: 'fl',
                            bm: 0,
                            hd: false,
                            mn: 'ADBE Vector Graphic - Fill',
                            nm: 'Fill 1',
                            c: {
                                a: 0,
                                k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1],
                                ix: 4
                            },
                            r: 1,
                            o: {
                                a: 0,
                                k: 100,
                                ix: 5
                            }
                        },
                        {
                            ty: 'tr',
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            p: {
                                a: 0,
                                k: [
                                    19.551,
                                    63.49
                                ],
                                ix: 2
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            }
                        }
                    ]
                }
            ],
            ind: 17
        }
    ],
    v: '5.7.0',
    fr: 30,
    op: 150,
    ip: 0,
    assets: []
});
